/* eslint-disable @typescript-eslint/default-param-last */
import {
  FieldAccessRule,
  LoanAccessRule,
  PersonaAccessResponse,
} from '@frontend/epc';
import {
  SET_FIELD_ACCESS_RULES,
  SET_LOAN_ACCESS_RULES,
  SET_PERSONA_ACCESS_DATA,
} from './actions';

const INITIAL_STATE = {
  allowedActions: [],
  fieldAccessRules: [],
  loanAccessRules: [],
};

type Action = {
  payload: PersonaAccessResponse[] | FieldAccessRule[] | LoanAccessRule[];
  type: string;
};

export default (state = INITIAL_STATE, action: Action) => {
  switch (action.type) {
    case SET_PERSONA_ACCESS_DATA:
      return {
        ...state,
        allowedActions: action.payload,
      };

    case SET_FIELD_ACCESS_RULES:
      return {
        ...state,
        fieldAccessRules: action.payload,
      };

    case SET_LOAN_ACCESS_RULES:
      return {
        ...state,
        loanAccessRules: action.payload,
      };

    default:
      return state;
  }
};
